"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hex2cmyk = exports.cmyk2hex = exports.rgbToHex = exports.rgb2cmyk = exports.cmyk2rgb = exports.hex2Rgb = void 0;

/**
 * Convert hex to RGB
 *
 * @param {string} hexString
 * @returns {RGBColor | null}
 */
var hex2Rgb = function hex2Rgb(hexString) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexString);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
};
/**
 * Convert CMYK to RGB
 *
 * @param {number} c
 * @param {number} m
 * @param {number} y
 * @param {number} k
 * @returns {RGBColor}
 */


exports.hex2Rgb = hex2Rgb;

var cmyk2rgb = function cmyk2rgb(c, m, y, k) {
  var K = k / 100;
  var C = c / 100 * (1 - K) + K;
  var M = m / 100 * (1 - K) + K;
  var Y = y / 100 * (1 - K) + K;
  var r = Math.round(255 * (1 - C));
  var g = Math.round(255 * (1 - M));
  var b = Math.round(255 * (1 - Y));
  return {
    r: r,
    g: g,
    b: b
  };
};
/**
 * Convert RGB to CMYK
 *
 * @param {number} r
 * @param {number} g
 * @param {number} b
 * @returns {CMYKColor}
 */


exports.cmyk2rgb = cmyk2rgb;

var rgb2cmyk = function rgb2cmyk(r, g, b) {
  var c = 1 - r / 255;
  var m = 1 - g / 255;
  var y = 1 - b / 255;
  var k = Math.min(c, Math.min(m, y));
  c = Math.round((c - k) / (1 - k) * 100);
  m = Math.round((m - k) / (1 - k) * 100);
  y = Math.round((y - k) / (1 - k) * 100);
  k = Math.round(k * 100);
  c = Number.isNaN(c) ? 0 : c;
  m = Number.isNaN(m) ? 0 : m;
  y = Number.isNaN(y) ? 0 : y;
  k = Number.isNaN(k) ? 0 : k;
  return {
    c: c,
    m: m,
    y: y,
    k: k
  };
};
/**
 * Convert RGM to HEX
 *
 * @param {number} r
 * @param {number} g
 * @param {number} b
 * @returns {string}
 */


exports.rgb2cmyk = rgb2cmyk;

var rgbToHex = function rgbToHex(r, g, b) {
  /**
   * Convert decimal number to hexadecimal string
   *
   * @param {number} c
   * @returns {string}
   */
  var componentToHex = function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
  };

  return "#".concat(componentToHex(r)).concat(componentToHex(g)).concat(componentToHex(b));
};
/**
 * Convert CMYK to HEX
 *
 * @param {number} c
 * @param {number} m
 * @param {number} y
 * @param {number} k
 * @returns {string}
 */


exports.rgbToHex = rgbToHex;

var cmyk2hex = function cmyk2hex(c, m, y, k) {
  var rgb = cmyk2rgb(c, m, y, k);
  return rgbToHex(rgb.r, rgb.g, rgb.b);
};
/**
 * Convert HEX to CMYK
 *
 * @param {string} hexString
 * @returns {{c: number, y: number, k: number, m: number}}
 */


exports.cmyk2hex = cmyk2hex;

var hex2cmyk = function hex2cmyk(hexString) {
  var RGB = hex2Rgb(hexString);

  if (RGB === null) {
    throw new Error('Invalid hex string');
  }

  return rgb2cmyk(RGB.r, RGB.g, RGB.b);
};

exports.hex2cmyk = hex2cmyk;